import { z } from 'zod'
import { idSchemaV2, isId } from '../../ids'
import { WithCompanyIdSchema } from '../../company'
import { AuditPropsSchema } from '../../common'
import { ArchivableSchema } from '../../archive'

export const CompliancePolicyIdSchema = idSchemaV2('CPolicy')
export type CompliancePolicyId = z.infer<typeof CompliancePolicyIdSchema>
export const isCompliancePolicyId = isId(CompliancePolicyIdSchema)

export const WithCompliancePolicyIdSchema = z.object({
  policyId: CompliancePolicyIdSchema,
})
export type WithCompliancePolicyId = z.infer<typeof WithCompliancePolicyIdSchema>

export const UnsavedCompliancePolicySchema = z.object({
  ...ArchivableSchema.shape,
  enabled: z.boolean().default(true),
  title: z.string().min(1).max(100),
  criteria: z.string().max(1000),
  exceptions: z.string().max(1000).optional(),
  reportDestinations: z.email().array().max(50).optional(),
  expireAfter: z.int().positive().optional(),
})
export type UnsavedCompliancePolicy = z.infer<typeof UnsavedCompliancePolicySchema>

export const CompliancePolicySchema = z.object({
  ...AuditPropsSchema.shape,
  ...WithCompanyIdSchema.shape,
  ...WithCompliancePolicyIdSchema.shape,
  ...UnsavedCompliancePolicySchema.shape,
})
export type CompliancePolicy = z.infer<typeof CompliancePolicySchema>
